/**
 * App-wide z-index hierarchy.
 *
 * All values sit above Leaflet's internal pane stacking (200–700 inside
 * .leaflet-container). Apply these to elements rendered outside or above
 * the map. Each layer leaves a gap so new components can slot in without
 * renumbering.
 *
 * Stacking order (bottom → top):
 *   bottomSheet → mapButton → mapOverlay → modal → navigationPanel →
 *   sidebar → toast → skipLink → debug
 */
export const Z_INDEX = {
  // L3 — Bottom sheets that don't fully cover the map.
  // Below floating map buttons so the location/zoom controls remain reachable.
  bottomSheet: 100,

  // L1 — Floating buttons on the map (location, zoom, compass).
  // Above bottom sheets, below content overlays.
  mapButton: 200,

  // L2 — Content overlays that cover/dock over the map (BigStopPage,
  // TourSummaryOverlay). Hides the floating map buttons by stacking above them.
  mapOverlay: 1000,

  // L4 — Modals and full-screen panels. Above map overlays.
  modal: 2000,

  // L4+ — Mobile travel-mode navigation panel. Sits just above modals so it
  // can be opened from inside other panels (e.g. filter, add-a-place).
  navigationPanel: 2500,

  // L5 — Sidebar / persistent app chrome. Always above modals.
  sidebar: 3000,

  // L6 — Toasts and accessibility live regions. Always reachable.
  toast: 4000,
  skipLink: 4500,

  // L7 — Dev/debug only.
  debug: 2147483647,
} as const;
